/**
 * 다운그레이드 적용일 정책 문구 - TermsModal.tsx(약관)/PlanPage.tsx(정책 안내 카드)가
 * 이 파일의 함수만 호출해서 문구를 만든다. 조건 판단(어떤 값일 때 어떤 문구인지)을
 * 이 파일 하나로 통일해, 한쪽만 고치고 다른 쪽을 놓치는 재발(2026-08-03 BE
 * estimatedDowngradeEffectiveDate 사례와 동일한 종류)을 막는 게 목적이다.
 *
 * nonEnterpriseDowngradeAppliesFirstOfMonth가 undefined(API 미응답/로딩 중)이면
 * 두 함수 다 보수적으로 "정확한 적용일은 화면에 표시된 날짜를 따른다"는 취지의
 * 안전한 폴백 문구를 반환한다 - 틀린 확정적 문구를 보여주는 것보다 안전하다.
 */

export function getDowngradeTermsClause(
  nonEnterpriseDowngradeAppliesFirstOfMonth: boolean | undefined,
): string {
  if (nonEnterpriseDowngradeAppliesFirstOfMonth === undefined) {
    return '다운그레이드는 월 1회로 제한되며, 서비스 화면에 안내되는 적용일부터 변경된 요금제가 적용됩니다. 다운그레이드 신청 취소는 적용일 전까지 가능합니다.';
  }
  if (nonEnterpriseDowngradeAppliesFirstOfMonth) {
    return '다운그레이드는 월 1회로 제한되며, 신청한 달의 다음 달 1일부터 변경된 요금제가 적용됩니다(엔터프라이즈 플랜은 별도 계약에 따릅니다). 다운그레이드 신청 취소는 적용일 전까지 가능합니다.';
  }
  return '다운그레이드는 월 1회로 제한되며, 현재 결제 주기가 끝나는 다음 날부터 변경된 요금제가 적용됩니다. 다운그레이드 신청 취소는 적용일 전까지 가능합니다.';
}

export function getDowngradePolicyCardText(
  nonEnterpriseDowngradeAppliesFirstOfMonth: boolean | undefined,
): string {
  if (nonEnterpriseDowngradeAppliesFirstOfMonth === undefined) {
    return '다운그레이드 요청 시 화면에 표시된 적용일에 자동으로 플랜이 변경됩니다.';
  }
  if (nonEnterpriseDowngradeAppliesFirstOfMonth) {
    return '다운그레이드 요청 시 다음 달 1일에 자동으로 플랜이 변경됩니다(엔터프라이즈 플랜 제외).';
  }
  return '다운그레이드 요청 시 설정한 날짜(다음 결제일)에 자동으로 플랜이 변경됩니다.';
}
